import './Home.css';
import {React, useState} from 'react';
import Draggable from 'react-draggable';
import img1 from "./images/galleryshots/FuguCam_1734928969.399842_0.jpg"
import img2 from "./images/galleryshots/FuguCam_1734929028.870493_0.jpg"
import img3 from "./images/galleryshots/FuguCam_1734929037.9389992_0.jpg"
import img4 from "./images/galleryshots/FuguCam_1734929102.9588342_14.jpg"
import img5 from "./images/galleryshots/FuguCam_1734929124.664182_14.jpg"
import img6 from "./images/galleryshots/FuguCam_1734929132.466322_14.jpg"

function DraggablePictures() {
  const [isDragging, setIsDragging] = useState(false);
  const handleStart = () => setIsDragging(true);
  const handleStop = () => setIsDragging(false);

  return (
    <div style={{position: 'absolute'}}>
        <div className={`box ${isDragging ? "dragging" : "dropped"}`}>
            <Draggable positionOffset={{x: '0%', y: '-100%'}} onStart={handleStart} onStop={handleStop}>
            <div>
                <img style={{transform: "rotate(-10deg)" }} className="img" src={img1} alt="Solia Singing"></img>
            </div>
            </Draggable>
        </div>
        <div className={`box ${isDragging ? "dragging" : "dropped"}`}>
            <Draggable positionOffset={{x: '50%', y: '-100%'}} onStart={handleStart} onStop={handleStop}>
                <div>
                    <img style={{transform: "rotate(8deg)" }} className="img" src={img2} alt="Snare drum"></img>
                </div>
            </Draggable>
        </div>
        <div className={`box ${isDragging ? "dragging" : "dropped"}`}>
        <Draggable positionOffset={{x: '-40%', y: '-150%'}} onStart={handleStart} onStop={handleStop}>
            <div>
            <img className="img vert" src={img3} alt="Pedalboard"></img>
            </div>
        </Draggable>
        </div>
        <div className={`box ${isDragging ? "dragging" : "dropped"}`}>
        <Draggable positionOffset={{x: '-173%', y: '-300%'}} onStart={handleStart} onStop={handleStop}>
            <div>
            <img style={{transform: "rotate(3deg)" }} className="img" src={img4} alt="Solia and Hunter"></img>
            </div>
        </Draggable>
        </div>
        <div className={`box ${isDragging ? "dragging" : "dropped"}`}>
        <Draggable positionOffset={{x: '-153%', y: '-550%'}} onStart={handleStart} onStop={handleStop}>
            <div>
            <img style={{transform: "rotate(-4deg)" }}className="img" src={img5} alt="Band Jam"></img>
            </div>
        </Draggable>
        </div>
        <div className={`box ${isDragging ? "dragging" : "dropped"}`}>
        <Draggable positionOffset={{x: '113%', y: '-660%'}} onStart={handleStart} onStop={handleStop}>
            <div>
            <img style={{transform: "rotate(2deg)" }} className="img" src={img6} alt="Tommy"></img>
            </div>
        </Draggable>
    </div>
</div>
  );
}

export default DraggablePictures;
